export default __webpack_public_path__ + "static/media/No45Open.8bc3ea4e.jpg";